
export class GalleryRequestList{
    dimPagina:number;
    numeroPagina:number;
    
}

export class GalleryRequest{
    name:string;
    previewImage:number;
    seoId:string;
    
}

export class GalleryRequestImages{ 
    imagesList: number[];
    
}


export class GalleryRequestPublish{
    id:number;
    published:boolean;
    
}



export class GalleryRequestSearch{
    name: string;
    pageNumber: number;
    pageSize: number;
    published: boolean;
    withPhoto: boolean;
    sortBy: string;
    
}